import Vue from 'vue'
import Vuex from 'vuex'

// Store modules
import auth from './auth'
import toast from './toast'
import sidebar from './sidebar'

Vue.use(Vuex)
export default new Vuex.Store({
	modules: {
		auth,
		toast,
		sidebar,
	},
})
